import {styled} from "@mui/material/styles"
import {Grid} from "@mui/material"

const ResultsGrid = styled(Grid, {
    shouldForwardProp: prop => !String(prop).startsWith("$"),
})<{$urlIsSaleOrClearance?: boolean}>`
    padding: 0;
    margin-top: 0.75rem;

    @media (min-width: ${({theme}) => theme.breakpoints.values.md}px) {
        padding: ${({$urlIsSaleOrClearance}) => ($urlIsSaleOrClearance ? "1.25rem 0 0 0" : "1.25rem 1rem 0 1rem")};
        margin-top: 0;
    }

    @media (min-width: ${({theme}) => theme.breakpoints.values.lg}px) {
        padding: 0.75rem 1rem 0 1rem;
    }

    @media (min-width: ${({theme}) => theme.breakpoints.values.xl}px) {
        padding: 0.75rem 1.5rem 0 1.5rem;
        position: relative;
    }
`

export default ResultsGrid
